import { render } from "./database-update.vue?vue&type=template&id=34246517&scoped=true&ts=true"
import script from "./database-update.vue?vue&type=script&setup=true&lang=ts"
export * from "./database-update.vue?vue&type=script&setup=true&lang=ts"

import "./database-update.vue?vue&type=style&index=0&id=34246517&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34246517"],['__file',"src/views/init/components/database-update.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34246517"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34246517', __exports__)) {
    console.log('reload')
    api.reload('34246517', __exports__)
  }
  
  module.hot.accept("./database-update.vue?vue&type=template&id=34246517&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('34246517', render)
  })

}


export default __exports__